module.exports = __webpack_public_path__ + "img/task-10-g.145a3a34.png";